const isStaging = process.env.NODE_ENV === 'development';

export default isStaging;
